import type { TextFieldProps } from '@mui/material';
import { TextField, InputAdornment } from '@mui/material';
import type { ChangeEventHandler, ReactNode } from 'react';

import { centsToFloat, convertToCents, floatToString } from '@woovi/utils';

import { useMask } from '../currency/useMask.tsx';

export type FloadNumberFieldProps = {
  value: string;
  onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  maxLength?: number;
  adorn?: string;
} & TextFieldProps;

const FloadNumberField = (props: FloadNumberFieldProps): ReactNode => {
  const { value, onChange, maxLength, adorn = 'R$', ...rest } = props;

  const rifm = useMask({
    value,
    onChange: (value) => {
      const event = {
        target: {
          value: convertToCents(value),
        },
      };

      onChange(event);
    },
    format: (str: string | number) => {
      const getValue = () => {
        if (!str) {
          return 0;
        }

        if (typeof str === 'number') {
          return str;
        }

        return parseInt(str.replaceAll(/\D/g, ''), 10);
      };

      const value = getValue();

      return floatToString(centsToFloat(value));
    },
  });

  return (
    <TextField
      type='text'
      variant='outlined'
      value={rifm.value}
      onChange={rifm.onChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>{adorn}</InputAdornment>
        ),
      }}
      {...rest}
    />
  );
};

export default FloadNumberField;
